import UptimeInlineStatus from "@/v2-backoffice-client/uptime/inline/UptimeInlineStatus"
import { useLayerUptimeTarget } from "@/v2-backoffice-client/layer/view/layer.view.uptime.hooks"

export type LayerViewUptimeStatusProps = {
  featureCode: string
  isProbing?: boolean
}

/** The layer sheet's "Uptime" info item: status, 24h uptime, 30-day bar, details link. */
function LayerViewUptimeStatus(props: LayerViewUptimeStatusProps) {
  const { featureCode, isProbing } = props
  const { target, isLoading, detailHref } = useLayerUptimeTarget({
    featureCode,
    isProbing,
  })

  return (
    <UptimeInlineStatus
      target={target}
      loading={isLoading}
      detailHref={detailHref}
    />
  )
}

export default LayerViewUptimeStatus
